import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';
import router from '@/router';

// constants
import { BASE_URL, LOGIN } from '@/constants/api/urls';

// types
import type LoginResponse from '@/models/response/loginResponse';


export const useAuthStore = defineStore('auth', () => {

  const jwtAuth = ref({});

  const getJwtAuth = () => {
    try {
      jwtAuth.value = JSON.parse(localStorage.getItem('jwt_auth')!);
      return jwtAuth.value;
    } catch(err) {
      console.log('getJwtAuthErr', err);
      return jwtAuth.value;
    }
  }

  const processLogin = async (username: string, password: string) => {

    try {

      const params = {
        username: username,
        password: password
      }

      const body = JSON.stringify(params);

      const response = await axios.post(
        `${BASE_URL}${LOGIN}`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true
        }
      );

      // update pinia state
      jwtAuth.value = response.data;

      // store user details and jwt in local storage to keep user logged in between page refreshes
      localStorage.setItem('jwt_auth', JSON.stringify(jwtAuth.value));

      router.push('/dashboard');

    } catch(error: any) {

      console.log(error);
      jwtAuth.value = {};
    }

  };

  return { jwtAuth, getJwtAuth, processLogin };
});